import { render, staticRenderFns } from "./NewPostButton.vue?vue&type=template&id=30117859&"
import script from "./NewPostButton.vue?vue&type=script&lang=js&"
export * from "./NewPostButton.vue?vue&type=script&lang=js&"
import style0 from "./NewPostButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports